import { compose, setDisplayName } from 'react-recompose';
import { reduxForm } from 'redux-form/immutable';

import { deleteFeatureFlag, postFeatureFlag } from '~/state/ducks/app/operations';
import { getFeatureFlags } from '~/state/ducks/app/selectors';

import withReduxConnect from '~/views/enhancers/withReduxConnect';

import FeatureFlags from '../components/FeatureFlags';


export default compose(
    setDisplayName('FeatureFlagsContainer'),
    withReduxConnect({
        mapStateToProps: state => ({
            feature_flags: getFeatureFlags(state),
        }),
        mapDispatchToProps: {
            handleDeleteFlag: deleteFeatureFlag,
        },
    }),
    reduxForm({
        form: 'feature_flag',
        onSubmit: postFeatureFlag,
    }),
)(FeatureFlags);

